<!--
 * @Description:  * @Description: 常规工作 学生请假 销假

 * @Author: 王赵坤
 * @Date: 2022-12-28 15:57:15
 * @LastEditors: PF
 * @LastEditTime: 2025-06-06 17:23:16
-->
<template>
  <div>
    <el-dialog class="w1200 h830" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">学生请假</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>

              <el-form-item>
                <el-select placeholder="系部" v-model="dataGrid.parms.xbid" clearable filterable @change="bindTable()">
                  <el-option v-for="item in xbData" :key="item.id" :label="item.jgmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select placeholder="专业" v-model="dataGrid.parms.zyid" clearable filterable @change="bindTable()">
                  <el-option v-for="item in zyData" :key="item.id" :label="item.zymc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select placeholder="年级" v-model="dataGrid.parms.njid" clearable filterable @change="initBanJi();bindTable()">
                  <el-option v-for="item in njData" :key="item.id" :label="item.njmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="dataGrid.parms.bjid" placeholder="请选择班级" @change="setxuesheng" clearable filterable>
                  <el-option v-for="item in banjilist" :key="item.id" :label="item.xzbmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="dataGrid.parms.zt" @change="bindTable()" placeholder="请选择状态" clearable filterable>
                  <!-- 0-已录入，1-已提交，9-审批通过，10-拒绝，20-生效，21-已销假 -->
                  <el-option v-for="(item, index) in sqztData.list" :key="index" :label="item.name" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="学号/姓名" v-model="dataGrid.parms.keyword" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
            <!-- 按钮区域 BEGIN -->
            <div class="button-box">
              <el-button type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>添加</el-button>
            </div>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <el-table-column label="序号" type="index" align="center" width="80" />
              <el-table-column label="学生姓名" prop="xm" align="center" show-overflow-tooltip />
              <el-table-column label="请假天数" prop="qjts" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span>{{scope.row.qjts}}天</span>
                </template>
              </el-table-column>
              <el-table-column label="请假时间" prop="" align="center" width="300">
                <template #default="scope">
                  <span v-if="scope.row.qjkssj !==null && scope.row.qjjssj !==null">
                    {{ scope.row.qjkssj }}至{{ scope.row.qjjssj }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="是否离校" fixed="right" align="center">
                <template #default="scope">
                  <span v-if="scope.row.sflx==true">是</span>
                  <span v-if="scope.row.sflx==false">否</span>
                </template>
              </el-table-column>
              <el-table-column label="销假操作人" prop="xjczrxm" align="center" show-overflow-tooltip />
              <el-table-column label="状态" fixed="right" prop="ztmc" align="center" width="90" />
              <!-- <el-table label="生效操作人"-column prop="sxczrid" align="center" show-overflow-tooltip /> -->
              <el-table-column label="操作" fixed="right" align="center" width="280">
                <template #default="scope">
                  <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
                  <el-button link type="primary" v-if="scope.row.ztval==sqztData.yiLuRu" @click="tijiaoClick(scope.row,1)">提交</el-button>
                  <el-button link type="primary" v-if="scope.row.ztval==sqztData.yiLuRu"  @click="openEdit=true; row=scope.row">修改</el-button>
                  <el-button link type="warning" v-if="scope.row.ztval==sqztData.yiLuRu"  @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <!-- 办理 弹窗 结束 -->
  <add v-if="openAdd" v-model:openAdd="openAdd" @ReturnData="bindTable" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
  <el-dialog class="w600 h530" v-model="centerDialogVisible" title="销假" width="500px">
    <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="120px" status-icon>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="实际请假天数" prop="sjqjts">
            <el-input-number v-model="ruleForm.sjqjts" placeholder="" :min="0" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="submitForm()">保存</el-button>
        <el-button @click="guanbixiaojia">关闭</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, unref } from 'vue'
import {
  loadList,
  submitDataGridAction,
  homeCloseWindow,
  loadSelect,
  actionPost
} from '@/api/common.js'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'
import pagination from '@/components/pagination.vue'
import add from './add.vue'
import edit from './edit.vue'
import detail from './detail.vue'

const props = defineProps({
  open: { type: String, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['openReturn', 'ReturnData'])

// 审批状态
const sqztData = ref({ list: [] })
loadSelect({ url: '/api/v2/jiaowu/xueshengqingjiajilu/xueshengqingjiazhuangtai', data: sqztData })

// 加载 系部 下拉框
const xbData = ref()
loadSelect({
  url: '/api/v2/xiaoneijigou/listxibu',
  data: xbData,
  order: 'jgh',
  sort: 'asc'
})
// 加载 专业 下拉框
const zyData = ref()
loadSelect({
  url: '/api/v2/pdp/zhuanye/list',
  data: zyData,
  order: 'zybh',
  sort: 'asc'
})
const njData = ref()
loadSelect({
  url: '/api/v2/pdp/nianji/list',
  data: njData,
  order: 'njdm',
  sort: 'asc'
})

// 搜索 结束
// 内容区域 开始
const banjilist = ref() // 班级数据
const centerDialogVisible = ref(false)
const ruleForm = ref({ sjqjts: null })
const ruleFormRef = ref()
const selectxqid = ref() // 学期
const xueshenglist = ref() // 学生
const rules = ref({
  sjqjts: [{ required: true, message: '学生不能为空', trigger: 'blur' }]
})
// 弹窗
const row = ref()
const openAdd = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)
const openList = ref(false)
const xiaojiaid = ref()
const istijiao = ref()
// 内容区域 结束

// 方法区域 开始
// 销假
const xiaohuiClick = (row, val) => {
  xiaojiaid.value = row.id
  centerDialogVisible.value = true
  istijiao.value = val
}
// 提交
const tijiaoClick = (row) => {
  const options = {
    url: '/api/v2/jiaowu/xueshengqingjiajilu/tijiao',
    data: {
      menuId: sessionStorage.getItem('menuId'),
      id: row.id,
      ids: [row.id]
    }
  } // [url]接口地址 [data]
  actionPost(options).then((res) => {
    if (res.code === 200) {
      bindTable()
      guanbixiaojia()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
const xqData = ref()
// 获取学期
const initSelectList = async () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: xqData,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq === true) {
          selectxqid.value = element.id
          getdengluren()
        }
      })
    }
  })
}
// 查询班级学生
const getbanjixueshenglist = () => {
  loadSelect({
    url: '/api/v2/pdp/xuesheng/banjixuesheng',
    data: xueshenglist,
    order: 'xh',
    parms: { bjid: dataGrid.value.parms.bjid },
    sort: 'asc'
  })
}
// 查询当前登陆人的班级
const getdengluren = () => {
  loadSelect({
    url: '/api/v2/pdp/banji/banzhuren',
    data: banjilist,
    order: 'xzbdm',
    parms: { xqid: selectxqid.value },
    sort: 'asc',
    loadSuccess: function () {
      getbanjixueshenglist()
    }
  })
}
// 关闭销假
const guanbixiaojia = () => {
  centerDialogVisible.value = false
  const form = unref(ruleFormRef)
  if (!form) return
  form.resetFields()
  xiaojiaid.value = ''
}
// 销假
const submitForm = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  const data = {
    menuId: sessionStorage.getItem('menuId'),
    id: xiaojiaid.value,
    ids: [xiaojiaid.value],
    sjqjts: ruleForm.value.sjqjts
  }
  if (istijiao.value === 0) {
    const options = {
      url: '/api/v2/jiaowu/xueshengqingjiajilu/xiaojia',
      data: data
    } // [url]接口地址 [data]
    actionPost(options).then((res) => {
      if (res.code === 200) {
        bindTable()
        guanbixiaojia()
        successPrompt(res.message)
      } else {
        warningPrompt(res.message)
      }
    })
  } else if (istijiao.value === 1) {
    const options = {
      url: '/api/v2/jiaowu/xueshengqingjiajilu/tijiao',
      data: data
    } // [url]接口地址 [data]
    actionPost(options).then((res) => {
      if (res.code === 200) {
        bindTable()
        guanbixiaojia()
        successPrompt(res.message)
      } else {
        warningPrompt(res.message)
      }
    })
  }
}
// 生效
const shengxiaoClick = (row) => {
  const data = {
    menuId: sessionStorage.getItem('menuId'),
    id: row.id
  }
  const options = {
    url: '/api/v2/jiaowu/xueshengqingjiajilu/xiaojia',
    data: data
  } // [url]接口地址 [data]
  actionPost(options).then((res) => {
    if (res.code === 200) {
      bindTable()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 列表
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'qjkssj', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/jiaowu/xueshengqingjiajilu/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
      dataGrid.value.data = res.data.list.map(item => {
        item.ztmc = item.zt ? item.zt.name : null
        item.ztval = item.zt ? item.zt.value : null
        return item
      })
    }
  })
}
// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/jiaowu/xueshengqingjiajilu',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function () {
      bindTable()
    }
  })
}
watch(
  () => props.open,
  () => {
    if (props.open === 'xueshengqingjia') {
      openList.value = true
      bindTable()
      initSelectList()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
